/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  AuditLogPage,
  CategoryStatistics,
  CustomerInsightsReport,
  DailyStatistics,
  DashboardStats,
  GetAuditLogsParams,
  GetDashboardDailyParams,
  GetDashboardRevenueChartParams,
  GetDashboardStatsParams,
  GetReportsCustomerInsightsParams,
  GetReportsSalesStatsParams,
  GetReportsStockTurnoverParams,
  GetReportsTopProductsParams,
  GetReportsVatInputParams,
  GetReportsWasteParams,
  GetStatisticsCategoriesParams,
  GetStatisticsProductsParams,
  GetStatisticsSalesParams,
  GetStatisticsVatParams,
  GetSystemLogsParams,
  LowStockItem,
  PostSystemLogsBody,
  ProductStatistics,
  RevenueChartPoint,
  SalesStatistics,
  SalesStatsReport,
  StockTurnover,
  StockValuation,
  SystemLogEntry,
  SystemLogPage,
  TopProduct,
  VatInputReport,
  VatStatistics,
  WasteReport,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getGetSystemLogsUrl = (params?: GetSystemLogsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/system-logs?${stringifiedParams}`
    : `/api/v1/system-logs`
}

/**
 * @summary What broke
 */
export const getSystemLogs = async (
  params?: GetSystemLogsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<SystemLogPage> => {
  return customFetch<SystemLogPage>(getGetSystemLogsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetSystemLogsQueryKey = (params?: GetSystemLogsParams) => {
  return [`/api/v1/system-logs`, ...(params ? [params] : [])] as const
}

export const getGetSystemLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSystemLogs>>,
  TError = unknown,
>(
  params?: GetSystemLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemLogs>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSystemLogsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSystemLogs>>> = ({ signal }) =>
    getSystemLogs(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSystemLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSystemLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getSystemLogs>>>
export type GetSystemLogsQueryError = unknown

export function useGetSystemLogs<
  TData = Awaited<ReturnType<typeof getSystemLogs>>,
  TError = unknown,
>(
  params: undefined | GetSystemLogsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemLogs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSystemLogs>>,
          TError,
          Awaited<ReturnType<typeof getSystemLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSystemLogs<
  TData = Awaited<ReturnType<typeof getSystemLogs>>,
  TError = unknown,
>(
  params?: GetSystemLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemLogs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSystemLogs>>,
          TError,
          Awaited<ReturnType<typeof getSystemLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSystemLogs<
  TData = Awaited<ReturnType<typeof getSystemLogs>>,
  TError = unknown,
>(
  params?: GetSystemLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemLogs>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What broke
 */

export function useGetSystemLogs<
  TData = Awaited<ReturnType<typeof getSystemLogs>>,
  TError = unknown,
>(
  params?: GetSystemLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemLogs>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSystemLogsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSystemLogsUrl = () => {
  return `/api/v1/system-logs`
}

/**
 * @summary Record a system-log line by hand
 */
export const postSystemLogs = async (
  postSystemLogsBody?: PostSystemLogsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<SystemLogEntry> => {
  return customFetch<SystemLogEntry>(getPostSystemLogsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSystemLogsBody),
  })
}

export const getPostSystemLogsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSystemLogs>>,
    TError,
    { data?: PostSystemLogsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSystemLogs>>,
  TError,
  { data?: PostSystemLogsBody },
  TContext
> => {
  const mutationKey = ['postSystemLogs']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSystemLogs>>,
    { data?: PostSystemLogsBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSystemLogs(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSystemLogsMutationResult = NonNullable<Awaited<ReturnType<typeof postSystemLogs>>>
export type PostSystemLogsMutationBody = PostSystemLogsBody | undefined
export type PostSystemLogsMutationError = unknown

/**
 * @summary Record a system-log line by hand
 */
export const usePostSystemLogs = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSystemLogs>>,
      TError,
      { data?: PostSystemLogsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSystemLogs>>,
  TError,
  { data?: PostSystemLogsBody },
  TContext
> => {
  return useMutation(getPostSystemLogsMutationOptions(options), queryClient)
}
export const getGetStatisticsVatUrl = (params?: GetStatisticsVatParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/statistics/vat?${stringifiedParams}`
    : `/api/v1/statistics/vat`
}

/**
 * One row per rate a line was charged at, read off the per-line snapshot rather than today's VAT categories - so a historical window reports what it actually took. BACKEND.md §10A.64.
 * @summary Sales by VAT rate
 */
export const getStatisticsVat = async (
  params?: GetStatisticsVatParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<VatStatistics[]> => {
  return customFetch<VatStatistics[]>(getGetStatisticsVatUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetStatisticsVatQueryKey = (params?: GetStatisticsVatParams) => {
  return [`/api/v1/statistics/vat`, ...(params ? [params] : [])] as const
}

export const getGetStatisticsVatQueryOptions = <
  TData = Awaited<ReturnType<typeof getStatisticsVat>>,
  TError = unknown,
>(
  params?: GetStatisticsVatParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatisticsVat>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStatisticsVatQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatisticsVat>>> = ({ signal }) =>
    getStatisticsVat(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStatisticsVat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStatisticsVatQueryResult = NonNullable<Awaited<ReturnType<typeof getStatisticsVat>>>
export type GetStatisticsVatQueryError = unknown

export function useGetStatisticsVat<
  TData = Awaited<ReturnType<typeof getStatisticsVat>>,
  TError = unknown,
>(
  params: undefined | GetStatisticsVatParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatisticsVat>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatisticsVat>>,
          TError,
          Awaited<ReturnType<typeof getStatisticsVat>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatisticsVat<
  TData = Awaited<ReturnType<typeof getStatisticsVat>>,
  TError = unknown,
>(
  params?: GetStatisticsVatParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatisticsVat>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatisticsVat>>,
          TError,
          Awaited<ReturnType<typeof getStatisticsVat>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatisticsVat<
  TData = Awaited<ReturnType<typeof getStatisticsVat>>,
  TError = unknown,
>(
  params?: GetStatisticsVatParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatisticsVat>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sales by VAT rate
 */

export function useGetStatisticsVat<
  TData = Awaited<ReturnType<typeof getStatisticsVat>>,
  TError = unknown,
>(
  params?: GetStatisticsVatParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatisticsVat>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStatisticsVatQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetStatisticsSalesUrl = (params?: GetStatisticsSalesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/statistics/sales?${stringifiedParams}`
    : `/api/v1/statistics/sales`
}

/**
 * @summary Sales over time
 */
export const getStatisticsSales = async (
  params?: GetStatisticsSalesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<SalesStatistics> => {
  return customFetch<SalesStatistics>(getGetStatisticsSalesUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetStatisticsSalesQueryKey = (params?: GetStatisticsSalesParams) => {
  return [`/api/v1/statistics/sales`, ...(params ? [params] : [])] as const
}

export const getGetStatisticsSalesQueryOptions = <
  TData = Awaited<ReturnType<typeof getStatisticsSales>>,
  TError = unknown,
>(
  params?: GetStatisticsSalesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatisticsSales>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStatisticsSalesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatisticsSales>>> = ({ signal }) =>
    getStatisticsSales(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStatisticsSales>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStatisticsSalesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStatisticsSales>>
>
export type GetStatisticsSalesQueryError = unknown

export function useGetStatisticsSales<
  TData = Awaited<ReturnType<typeof getStatisticsSales>>,
  TError = unknown,
>(
  params: undefined | GetStatisticsSalesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatisticsSales>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatisticsSales>>,
          TError,
          Awaited<ReturnType<typeof getStatisticsSales>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatisticsSales<
  TData = Awaited<ReturnType<typeof getStatisticsSales>>,
  TError = unknown,
>(
  params?: GetStatisticsSalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatisticsSales>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatisticsSales>>,
          TError,
          Awaited<ReturnType<typeof getStatisticsSales>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatisticsSales<
  TData = Awaited<ReturnType<typeof getStatisticsSales>>,
  TError = unknown,
>(
  params?: GetStatisticsSalesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatisticsSales>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sales over time
 */

export function useGetStatisticsSales<
  TData = Awaited<ReturnType<typeof getStatisticsSales>>,
  TError = unknown,
>(
  params?: GetStatisticsSalesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatisticsSales>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStatisticsSalesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetStatisticsProductsUrl = (params?: GetStatisticsProductsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/statistics/products?${stringifiedParams}`
    : `/api/v1/statistics/products`
}

/**
 * @summary Sales by product
 */
export const getStatisticsProducts = async (
  params?: GetStatisticsProductsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ProductStatistics[]> => {
  return customFetch<ProductStatistics[]>(getGetStatisticsProductsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetStatisticsProductsQueryKey = (params?: GetStatisticsProductsParams) => {
  return [`/api/v1/statistics/products`, ...(params ? [params] : [])] as const
}

export const getGetStatisticsProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStatisticsProducts>>,
  TError = unknown,
>(
  params?: GetStatisticsProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatisticsProducts>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStatisticsProductsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatisticsProducts>>> = ({ signal }) =>
    getStatisticsProducts(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStatisticsProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStatisticsProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStatisticsProducts>>
>
export type GetStatisticsProductsQueryError = unknown

export function useGetStatisticsProducts<
  TData = Awaited<ReturnType<typeof getStatisticsProducts>>,
  TError = unknown,
>(
  params: undefined | GetStatisticsProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatisticsProducts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatisticsProducts>>,
          TError,
          Awaited<ReturnType<typeof getStatisticsProducts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatisticsProducts<
  TData = Awaited<ReturnType<typeof getStatisticsProducts>>,
  TError = unknown,
>(
  params?: GetStatisticsProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatisticsProducts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatisticsProducts>>,
          TError,
          Awaited<ReturnType<typeof getStatisticsProducts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatisticsProducts<
  TData = Awaited<ReturnType<typeof getStatisticsProducts>>,
  TError = unknown,
>(
  params?: GetStatisticsProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatisticsProducts>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sales by product
 */

export function useGetStatisticsProducts<
  TData = Awaited<ReturnType<typeof getStatisticsProducts>>,
  TError = unknown,
>(
  params?: GetStatisticsProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatisticsProducts>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStatisticsProductsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetStatisticsCategoriesUrl = (params?: GetStatisticsCategoriesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/statistics/categories?${stringifiedParams}`
    : `/api/v1/statistics/categories`
}

/**
 * @summary Sales by category
 */
export const getStatisticsCategories = async (
  params?: GetStatisticsCategoriesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<CategoryStatistics[]> => {
  return customFetch<CategoryStatistics[]>(getGetStatisticsCategoriesUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetStatisticsCategoriesQueryKey = (params?: GetStatisticsCategoriesParams) => {
  return [`/api/v1/statistics/categories`, ...(params ? [params] : [])] as const
}

export const getGetStatisticsCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getStatisticsCategories>>,
  TError = unknown,
>(
  params?: GetStatisticsCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatisticsCategories>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStatisticsCategoriesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatisticsCategories>>> = ({
    signal,
  }) => getStatisticsCategories(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStatisticsCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStatisticsCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStatisticsCategories>>
>
export type GetStatisticsCategoriesQueryError = unknown

export function useGetStatisticsCategories<
  TData = Awaited<ReturnType<typeof getStatisticsCategories>>,
  TError = unknown,
>(
  params: undefined | GetStatisticsCategoriesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatisticsCategories>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatisticsCategories>>,
          TError,
          Awaited<ReturnType<typeof getStatisticsCategories>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatisticsCategories<
  TData = Awaited<ReturnType<typeof getStatisticsCategories>>,
  TError = unknown,
>(
  params?: GetStatisticsCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatisticsCategories>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatisticsCategories>>,
          TError,
          Awaited<ReturnType<typeof getStatisticsCategories>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatisticsCategories<
  TData = Awaited<ReturnType<typeof getStatisticsCategories>>,
  TError = unknown,
>(
  params?: GetStatisticsCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatisticsCategories>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sales by category
 */

export function useGetStatisticsCategories<
  TData = Awaited<ReturnType<typeof getStatisticsCategories>>,
  TError = unknown,
>(
  params?: GetStatisticsCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatisticsCategories>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStatisticsCategoriesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetReportsWasteUrl = (params?: GetReportsWasteParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/reports/waste?${stringifiedParams}`
    : `/api/v1/reports/waste`
}

/**
 * @summary What was thrown away, and what it cost
 */
export const getReportsWaste = async (
  params?: GetReportsWasteParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<WasteReport> => {
  return customFetch<WasteReport>(getGetReportsWasteUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetReportsWasteQueryKey = (params?: GetReportsWasteParams) => {
  return [`/api/v1/reports/waste`, ...(params ? [params] : [])] as const
}

export const getGetReportsWasteQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsWaste>>,
  TError = unknown,
>(
  params?: GetReportsWasteParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsWaste>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReportsWasteQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsWaste>>> = ({ signal }) =>
    getReportsWaste(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsWaste>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsWasteQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsWaste>>>
export type GetReportsWasteQueryError = unknown

export function useGetReportsWaste<
  TData = Awaited<ReturnType<typeof getReportsWaste>>,
  TError = unknown,
>(
  params: undefined | GetReportsWasteParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsWaste>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsWaste>>,
          TError,
          Awaited<ReturnType<typeof getReportsWaste>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsWaste<
  TData = Awaited<ReturnType<typeof getReportsWaste>>,
  TError = unknown,
>(
  params?: GetReportsWasteParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsWaste>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsWaste>>,
          TError,
          Awaited<ReturnType<typeof getReportsWaste>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsWaste<
  TData = Awaited<ReturnType<typeof getReportsWaste>>,
  TError = unknown,
>(
  params?: GetReportsWasteParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsWaste>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What was thrown away, and what it cost
 */

export function useGetReportsWaste<
  TData = Awaited<ReturnType<typeof getReportsWaste>>,
  TError = unknown,
>(
  params?: GetReportsWasteParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsWaste>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsWasteQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetReportsVatInputUrl = (params?: GetReportsVatInputParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/reports/vat-input?${stringifiedParams}`
    : `/api/v1/reports/vat-input`
}

/**
 * @summary Input VAT for a period
 */
export const getReportsVatInput = async (
  params?: GetReportsVatInputParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<VatInputReport> => {
  return customFetch<VatInputReport>(getGetReportsVatInputUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetReportsVatInputQueryKey = (params?: GetReportsVatInputParams) => {
  return [`/api/v1/reports/vat-input`, ...(params ? [params] : [])] as const
}

export const getGetReportsVatInputQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsVatInput>>,
  TError = unknown,
>(
  params?: GetReportsVatInputParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsVatInput>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReportsVatInputQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsVatInput>>> = ({ signal }) =>
    getReportsVatInput(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsVatInput>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsVatInputQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsVatInput>>
>
export type GetReportsVatInputQueryError = unknown

export function useGetReportsVatInput<
  TData = Awaited<ReturnType<typeof getReportsVatInput>>,
  TError = unknown,
>(
  params: undefined | GetReportsVatInputParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsVatInput>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsVatInput>>,
          TError,
          Awaited<ReturnType<typeof getReportsVatInput>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsVatInput<
  TData = Awaited<ReturnType<typeof getReportsVatInput>>,
  TError = unknown,
>(
  params?: GetReportsVatInputParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsVatInput>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsVatInput>>,
          TError,
          Awaited<ReturnType<typeof getReportsVatInput>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsVatInput<
  TData = Awaited<ReturnType<typeof getReportsVatInput>>,
  TError = unknown,
>(
  params?: GetReportsVatInputParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsVatInput>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Input VAT for a period
 */

export function useGetReportsVatInput<
  TData = Awaited<ReturnType<typeof getReportsVatInput>>,
  TError = unknown,
>(
  params?: GetReportsVatInputParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsVatInput>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsVatInputQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetReportsTopProductsUrl = (params?: GetReportsTopProductsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/reports/top-products?${stringifiedParams}`
    : `/api/v1/reports/top-products`
}

/**
 * @summary What sells
 */
export const getReportsTopProducts = async (
  params?: GetReportsTopProductsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<TopProduct[]> => {
  return customFetch<TopProduct[]>(getGetReportsTopProductsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetReportsTopProductsQueryKey = (params?: GetReportsTopProductsParams) => {
  return [`/api/v1/reports/top-products`, ...(params ? [params] : [])] as const
}

export const getGetReportsTopProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsTopProducts>>,
  TError = unknown,
>(
  params?: GetReportsTopProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsTopProducts>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReportsTopProductsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsTopProducts>>> = ({ signal }) =>
    getReportsTopProducts(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsTopProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsTopProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsTopProducts>>
>
export type GetReportsTopProductsQueryError = unknown

export function useGetReportsTopProducts<
  TData = Awaited<ReturnType<typeof getReportsTopProducts>>,
  TError = unknown,
>(
  params: undefined | GetReportsTopProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsTopProducts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsTopProducts>>,
          TError,
          Awaited<ReturnType<typeof getReportsTopProducts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsTopProducts<
  TData = Awaited<ReturnType<typeof getReportsTopProducts>>,
  TError = unknown,
>(
  params?: GetReportsTopProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsTopProducts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsTopProducts>>,
          TError,
          Awaited<ReturnType<typeof getReportsTopProducts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsTopProducts<
  TData = Awaited<ReturnType<typeof getReportsTopProducts>>,
  TError = unknown,
>(
  params?: GetReportsTopProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsTopProducts>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What sells
 */

export function useGetReportsTopProducts<
  TData = Awaited<ReturnType<typeof getReportsTopProducts>>,
  TError = unknown,
>(
  params?: GetReportsTopProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsTopProducts>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsTopProductsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetReportsStockValuationUrl = () => {
  return `/api/v1/reports/stock-valuation`
}

/**
 * @summary What the shelves are worth
 */
export const getReportsStockValuation = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<StockValuation> => {
  return customFetch<StockValuation>(getGetReportsStockValuationUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetReportsStockValuationQueryKey = () => {
  return [`/api/v1/reports/stock-valuation`] as const
}

export const getGetReportsStockValuationQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsStockValuation>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getReportsStockValuation>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReportsStockValuationQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsStockValuation>>> = ({
    signal,
  }) => getReportsStockValuation({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsStockValuation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsStockValuationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsStockValuation>>
>
export type GetReportsStockValuationQueryError = unknown

export function useGetReportsStockValuation<
  TData = Awaited<ReturnType<typeof getReportsStockValuation>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsStockValuation>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsStockValuation>>,
          TError,
          Awaited<ReturnType<typeof getReportsStockValuation>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsStockValuation<
  TData = Awaited<ReturnType<typeof getReportsStockValuation>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsStockValuation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsStockValuation>>,
          TError,
          Awaited<ReturnType<typeof getReportsStockValuation>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsStockValuation<
  TData = Awaited<ReturnType<typeof getReportsStockValuation>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsStockValuation>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What the shelves are worth
 */

export function useGetReportsStockValuation<
  TData = Awaited<ReturnType<typeof getReportsStockValuation>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsStockValuation>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsStockValuationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetReportsStockTurnoverUrl = (params?: GetReportsStockTurnoverParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/reports/stock-turnover?${stringifiedParams}`
    : `/api/v1/reports/stock-turnover`
}

/**
 * @summary What moves and what sits
 */
export const getReportsStockTurnover = async (
  params?: GetReportsStockTurnoverParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<StockTurnover> => {
  return customFetch<StockTurnover>(getGetReportsStockTurnoverUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetReportsStockTurnoverQueryKey = (params?: GetReportsStockTurnoverParams) => {
  return [`/api/v1/reports/stock-turnover`, ...(params ? [params] : [])] as const
}

export const getGetReportsStockTurnoverQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsStockTurnover>>,
  TError = unknown,
>(
  params?: GetReportsStockTurnoverParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsStockTurnover>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReportsStockTurnoverQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsStockTurnover>>> = ({
    signal,
  }) => getReportsStockTurnover(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsStockTurnover>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsStockTurnoverQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsStockTurnover>>
>
export type GetReportsStockTurnoverQueryError = unknown

export function useGetReportsStockTurnover<
  TData = Awaited<ReturnType<typeof getReportsStockTurnover>>,
  TError = unknown,
>(
  params: undefined | GetReportsStockTurnoverParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsStockTurnover>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsStockTurnover>>,
          TError,
          Awaited<ReturnType<typeof getReportsStockTurnover>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsStockTurnover<
  TData = Awaited<ReturnType<typeof getReportsStockTurnover>>,
  TError = unknown,
>(
  params?: GetReportsStockTurnoverParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsStockTurnover>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsStockTurnover>>,
          TError,
          Awaited<ReturnType<typeof getReportsStockTurnover>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsStockTurnover<
  TData = Awaited<ReturnType<typeof getReportsStockTurnover>>,
  TError = unknown,
>(
  params?: GetReportsStockTurnoverParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsStockTurnover>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What moves and what sits
 */

export function useGetReportsStockTurnover<
  TData = Awaited<ReturnType<typeof getReportsStockTurnover>>,
  TError = unknown,
>(
  params?: GetReportsStockTurnoverParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsStockTurnover>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsStockTurnoverQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetReportsSalesStatsUrl = (params?: GetReportsSalesStatsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/reports/sales-stats?${stringifiedParams}`
    : `/api/v1/reports/sales-stats`
}

/**
 * @summary The shape of trade over a window
 */
export const getReportsSalesStats = async (
  params?: GetReportsSalesStatsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<SalesStatsReport> => {
  return customFetch<SalesStatsReport>(getGetReportsSalesStatsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetReportsSalesStatsQueryKey = (params?: GetReportsSalesStatsParams) => {
  return [`/api/v1/reports/sales-stats`, ...(params ? [params] : [])] as const
}

export const getGetReportsSalesStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsSalesStats>>,
  TError = unknown,
>(
  params?: GetReportsSalesStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsSalesStats>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReportsSalesStatsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsSalesStats>>> = ({ signal }) =>
    getReportsSalesStats(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsSalesStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsSalesStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsSalesStats>>
>
export type GetReportsSalesStatsQueryError = unknown

export function useGetReportsSalesStats<
  TData = Awaited<ReturnType<typeof getReportsSalesStats>>,
  TError = unknown,
>(
  params: undefined | GetReportsSalesStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsSalesStats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsSalesStats>>,
          TError,
          Awaited<ReturnType<typeof getReportsSalesStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsSalesStats<
  TData = Awaited<ReturnType<typeof getReportsSalesStats>>,
  TError = unknown,
>(
  params?: GetReportsSalesStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsSalesStats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsSalesStats>>,
          TError,
          Awaited<ReturnType<typeof getReportsSalesStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsSalesStats<
  TData = Awaited<ReturnType<typeof getReportsSalesStats>>,
  TError = unknown,
>(
  params?: GetReportsSalesStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsSalesStats>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The shape of trade over a window
 */

export function useGetReportsSalesStats<
  TData = Awaited<ReturnType<typeof getReportsSalesStats>>,
  TError = unknown,
>(
  params?: GetReportsSalesStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsSalesStats>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsSalesStatsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetReportsLowStockUrl = () => {
  return `/api/v1/reports/low-stock`
}

/**
 * @summary Everything below its minimum
 */
export const getReportsLowStock = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<LowStockItem[]> => {
  return customFetch<LowStockItem[]>(getGetReportsLowStockUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetReportsLowStockQueryKey = () => {
  return [`/api/v1/reports/low-stock`] as const
}

export const getGetReportsLowStockQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsLowStock>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsLowStock>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReportsLowStockQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsLowStock>>> = ({ signal }) =>
    getReportsLowStock({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsLowStock>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsLowStockQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsLowStock>>
>
export type GetReportsLowStockQueryError = unknown

export function useGetReportsLowStock<
  TData = Awaited<ReturnType<typeof getReportsLowStock>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsLowStock>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsLowStock>>,
          TError,
          Awaited<ReturnType<typeof getReportsLowStock>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsLowStock<
  TData = Awaited<ReturnType<typeof getReportsLowStock>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsLowStock>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsLowStock>>,
          TError,
          Awaited<ReturnType<typeof getReportsLowStock>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsLowStock<
  TData = Awaited<ReturnType<typeof getReportsLowStock>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsLowStock>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Everything below its minimum
 */

export function useGetReportsLowStock<
  TData = Awaited<ReturnType<typeof getReportsLowStock>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsLowStock>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsLowStockQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetReportsCustomerInsightsUrl = (params?: GetReportsCustomerInsightsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/reports/customer-insights?${stringifiedParams}`
    : `/api/v1/reports/customer-insights`
}

/**
 * @summary Who orders, and how many come back
 */
export const getReportsCustomerInsights = async (
  params?: GetReportsCustomerInsightsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerInsightsReport> => {
  return customFetch<CustomerInsightsReport>(getGetReportsCustomerInsightsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetReportsCustomerInsightsQueryKey = (
  params?: GetReportsCustomerInsightsParams,
) => {
  return [`/api/v1/reports/customer-insights`, ...(params ? [params] : [])] as const
}

export const getGetReportsCustomerInsightsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsCustomerInsights>>,
  TError = unknown,
>(
  params?: GetReportsCustomerInsightsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsCustomerInsights>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReportsCustomerInsightsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsCustomerInsights>>> = ({
    signal,
  }) => getReportsCustomerInsights(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsCustomerInsights>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsCustomerInsightsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsCustomerInsights>>
>
export type GetReportsCustomerInsightsQueryError = unknown

export function useGetReportsCustomerInsights<
  TData = Awaited<ReturnType<typeof getReportsCustomerInsights>>,
  TError = unknown,
>(
  params: undefined | GetReportsCustomerInsightsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsCustomerInsights>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsCustomerInsights>>,
          TError,
          Awaited<ReturnType<typeof getReportsCustomerInsights>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsCustomerInsights<
  TData = Awaited<ReturnType<typeof getReportsCustomerInsights>>,
  TError = unknown,
>(
  params?: GetReportsCustomerInsightsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsCustomerInsights>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsCustomerInsights>>,
          TError,
          Awaited<ReturnType<typeof getReportsCustomerInsights>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsCustomerInsights<
  TData = Awaited<ReturnType<typeof getReportsCustomerInsights>>,
  TError = unknown,
>(
  params?: GetReportsCustomerInsightsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsCustomerInsights>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Who orders, and how many come back
 */

export function useGetReportsCustomerInsights<
  TData = Awaited<ReturnType<typeof getReportsCustomerInsights>>,
  TError = unknown,
>(
  params?: GetReportsCustomerInsightsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsCustomerInsights>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportsCustomerInsightsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetDashboardStatsUrl = (params?: GetDashboardStatsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/dashboard/stats?${stringifiedParams}`
    : `/api/v1/dashboard/stats`
}

/**
 * @summary The day's takings, split by channel and payment
 */
export const getDashboardStats = async (
  params?: GetDashboardStatsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DashboardStats> => {
  return customFetch<DashboardStats>(getGetDashboardStatsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetDashboardStatsQueryKey = (params?: GetDashboardStatsParams) => {
  return [`/api/v1/dashboard/stats`, ...(params ? [params] : [])] as const
}

export const getGetDashboardStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardStats>>,
  TError = unknown,
>(
  params?: GetDashboardStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDashboardStatsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardStats>>> = ({ signal }) =>
    getDashboardStats(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardStats>>
>
export type GetDashboardStatsQueryError = unknown

export function useGetDashboardStats<
  TData = Awaited<ReturnType<typeof getDashboardStats>>,
  TError = unknown,
>(
  params: undefined | GetDashboardStatsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardStats>>,
          TError,
          Awaited<ReturnType<typeof getDashboardStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardStats<
  TData = Awaited<ReturnType<typeof getDashboardStats>>,
  TError = unknown,
>(
  params?: GetDashboardStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardStats>>,
          TError,
          Awaited<ReturnType<typeof getDashboardStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardStats<
  TData = Awaited<ReturnType<typeof getDashboardStats>>,
  TError = unknown,
>(
  params?: GetDashboardStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The day's takings, split by channel and payment
 */

export function useGetDashboardStats<
  TData = Awaited<ReturnType<typeof getDashboardStats>>,
  TError = unknown,
>(
  params?: GetDashboardStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDashboardStatsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetDashboardRevenueChartUrl = (params?: GetDashboardRevenueChartParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/dashboard/revenue-chart?${stringifiedParams}`
    : `/api/v1/dashboard/revenue-chart`
}

/**
 * @summary When the money came in
 */
export const getDashboardRevenueChart = async (
  params?: GetDashboardRevenueChartParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<RevenueChartPoint[]> => {
  return customFetch<RevenueChartPoint[]>(getGetDashboardRevenueChartUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetDashboardRevenueChartQueryKey = (params?: GetDashboardRevenueChartParams) => {
  return [`/api/v1/dashboard/revenue-chart`, ...(params ? [params] : [])] as const
}

export const getGetDashboardRevenueChartQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardRevenueChart>>,
  TError = unknown,
>(
  params?: GetDashboardRevenueChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardRevenueChart>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDashboardRevenueChartQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardRevenueChart>>> = ({
    signal,
  }) => getDashboardRevenueChart(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardRevenueChart>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardRevenueChartQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardRevenueChart>>
>
export type GetDashboardRevenueChartQueryError = unknown

export function useGetDashboardRevenueChart<
  TData = Awaited<ReturnType<typeof getDashboardRevenueChart>>,
  TError = unknown,
>(
  params: undefined | GetDashboardRevenueChartParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardRevenueChart>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardRevenueChart>>,
          TError,
          Awaited<ReturnType<typeof getDashboardRevenueChart>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardRevenueChart<
  TData = Awaited<ReturnType<typeof getDashboardRevenueChart>>,
  TError = unknown,
>(
  params?: GetDashboardRevenueChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardRevenueChart>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardRevenueChart>>,
          TError,
          Awaited<ReturnType<typeof getDashboardRevenueChart>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardRevenueChart<
  TData = Awaited<ReturnType<typeof getDashboardRevenueChart>>,
  TError = unknown,
>(
  params?: GetDashboardRevenueChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardRevenueChart>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary When the money came in
 */

export function useGetDashboardRevenueChart<
  TData = Awaited<ReturnType<typeof getDashboardRevenueChart>>,
  TError = unknown,
>(
  params?: GetDashboardRevenueChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDashboardRevenueChart>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDashboardRevenueChartQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetDashboardDailyUrl = (params?: GetDashboardDailyParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/dashboard/daily?${stringifiedParams}`
    : `/api/v1/dashboard/daily`
}

/**
 * @summary One row per day for the table under the chart
 */
export const getDashboardDaily = async (
  params?: GetDashboardDailyParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DailyStatistics[]> => {
  return customFetch<DailyStatistics[]>(getGetDashboardDailyUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetDashboardDailyQueryKey = (params?: GetDashboardDailyParams) => {
  return [`/api/v1/dashboard/daily`, ...(params ? [params] : [])] as const
}

export const getGetDashboardDailyQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardDaily>>,
  TError = unknown,
>(
  params?: GetDashboardDailyParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDaily>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDashboardDailyQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardDaily>>> = ({ signal }) =>
    getDashboardDaily(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardDaily>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardDailyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardDaily>>
>
export type GetDashboardDailyQueryError = unknown

export function useGetDashboardDaily<
  TData = Awaited<ReturnType<typeof getDashboardDaily>>,
  TError = unknown,
>(
  params: undefined | GetDashboardDailyParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDaily>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardDaily>>,
          TError,
          Awaited<ReturnType<typeof getDashboardDaily>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardDaily<
  TData = Awaited<ReturnType<typeof getDashboardDaily>>,
  TError = unknown,
>(
  params?: GetDashboardDailyParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDaily>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardDaily>>,
          TError,
          Awaited<ReturnType<typeof getDashboardDaily>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardDaily<
  TData = Awaited<ReturnType<typeof getDashboardDaily>>,
  TError = unknown,
>(
  params?: GetDashboardDailyParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDaily>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One row per day for the table under the chart
 */

export function useGetDashboardDaily<
  TData = Awaited<ReturnType<typeof getDashboardDaily>>,
  TError = unknown,
>(
  params?: GetDashboardDailyParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDaily>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDashboardDailyQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAuditLogsUrl = (params?: GetAuditLogsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/audit-logs?${stringifiedParams}`
    : `/api/v1/audit-logs`
}

/**
 * `search` matches the actor's name, the action, the entity kind, its id, or anything in the entry's `detail` - across the whole table, not the page. Optional and additive: a caller that omits it sees exactly what it saw before.
 * @summary Who changed what
 */
export const getAuditLogs = async (
  params?: GetAuditLogsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<AuditLogPage> => {
  return customFetch<AuditLogPage>(getGetAuditLogsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAuditLogsQueryKey = (params?: GetAuditLogsParams) => {
  return [`/api/v1/audit-logs`, ...(params ? [params] : [])] as const
}

export const getGetAuditLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuditLogs>>,
  TError = unknown,
>(
  params?: GetAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditLogs>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAuditLogsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditLogs>>> = ({ signal }) =>
    getAuditLogs(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuditLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditLogs>>>
export type GetAuditLogsQueryError = unknown

export function useGetAuditLogs<TData = Awaited<ReturnType<typeof getAuditLogs>>, TError = unknown>(
  params: undefined | GetAuditLogsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditLogs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getAuditLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditLogs<TData = Awaited<ReturnType<typeof getAuditLogs>>, TError = unknown>(
  params?: GetAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditLogs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getAuditLogs>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditLogs<TData = Awaited<ReturnType<typeof getAuditLogs>>, TError = unknown>(
  params?: GetAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditLogs>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Who changed what
 */

export function useGetAuditLogs<TData = Awaited<ReturnType<typeof getAuditLogs>>, TError = unknown>(
  params?: GetAuditLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditLogs>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAuditLogsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
